import React from "react";
import "./styles.scss";
import "./mobile.scss";
import { ntbLogo } from "../../../assets/img";
import darazLogo from "../../../assets/img/daraz-logo.png";
import Theme from "../../../constants/theme";

const Index = () => {
  const theme = sessionStorage.getItem(Theme.KEY);

  return (
    <>
      <div className={"main-header-wrapper d-flex"}>
        <div className={"mh-inner-wrapper d-flex justify-content-between align-items-center"}>
          <div className={"mh-bank-logo"}>
            {theme ? (
              <div className="logo-img-wrapper">
                <img
                  className="animate_animated animate_fadeInDown daraz-logo"
                  src={darazLogo}
                  alt="Daraz online banking"
                />

                <img className="animate_animated animate_fadeInDown mh-logo" src={ntbLogo} alt="NTB online banking" />
              </div>
            ) : (
              <img className="animate_animated animate_fadeInDown mh-logo" src={ntbLogo} alt="NTB online banking" />
            )}
          </div>
          <div className={"login-btn-wrapper"} />
        </div>
      </div>
    </>
  );
};
export default Index;
